export const escapeForbiddenSymbolsInQuery = (query: string) =>
  query ? `${query.replace(/[\\"*?]/g, '\\$&')}` : '';
